import { useEffect, useState } from "react";

interface useNetConnectionProps {
  onChange?: (isOnline: boolean) => void;
}

const useNetConnection = ({ onChange }: useNetConnectionProps) => {
  const [isNetConnected, setIsNetConnected] = useState<boolean>(
    navigator.onLine
  );

  useEffect(() => {
    const listener = (e: any) => {
      const isOnline = e.type === "online";
      setIsNetConnected(isOnline);
      onChange?.(isOnline);
    };
    window.addEventListener("offline", listener);
    window.addEventListener("online", listener);
    return () => {
      window.removeEventListener("offline", listener);
      window.removeEventListener("online", listener);
    };
  }, []);

  return isNetConnected;
};

export default useNetConnection;
